import { Country } from 'api';
import { yup } from 'form';

import { basePurchaseOrderFormSchema } from './basePurchaseOrderSchema';

export const createPurchaseOrderSchema = basePurchaseOrderFormSchema.shape({
  final_destination_country: yup.string().oneOf(Object.values(Country)).required(),
  number_of_loads: yup
    .string()
    .required()
    .test('is-positive-integer', 'Must be a positive whole number', (value) => {
      if (!value) return false;
      const num = Number(value);
      return Number.isInteger(num) && num > 0;
    }),
  site_material_id: yup.number().required(),
});
